import SectionsResolver from "@/utils/sections-resolver";

const ACCOUNT_SECTION = "recevier";
const BILLING_ADDRESS_SECTION = "billing_address";
const SHIPPING_ADDRESS_SECTION = "receiver_shipping_address";
const PAYMENT_SECTION = "payment_method";
const SUBSCRIPTION_SECTION = "subscription";
const GIFT_SECTION = "gift_details";
const SECTIONS = [SUBSCRIPTION_SECTION, GIFT_SECTION, BILLING_ADDRESS_SECTION, ACCOUNT_SECTION, SHIPPING_ADDRESS_SECTION, PAYMENT_SECTION];
export const GIFT_ACC_FIELDS = ['email', 'first_name', 'last_name'];

export default class GiftSectionsResolver extends SectionsResolver {
  constructor() {
    super();
  }

  resolve(state, rootState, dispatch, getters) {
    SECTIONS.forEach(section => this[section](state, rootState, dispatch, getters));
  }

  [ACCOUNT_SECTION](state, rootState, dispatch, getters) {
    // if customer section is enabled
    // and if auto claim in enabled and the receiver is not an existing customer
    let fields = state.checkout_new.sections.customer.fields;
    fields = fields.filter(i => GIFT_ACC_FIELDS.indexOf(i.name) == -1);
    if(fields.length > 0
      && getters.gift_config && getters.gift_config.auto_claim_enabled
      && !getters.gift_receiver.existing) {
        this.steps.push("customer");
    }
  }

  [BILLING_ADDRESS_SECTION](state, rootState, dispatch, getters) {
    super[BILLING_ADDRESS_SECTION](state, rootState, dispatch, getters)
  }

  [SHIPPING_ADDRESS_SECTION](state, rootState, dispatch, getters) {
    if (
      state.checkout_new.sections.shipping_address.fields.length > 0 &&
      getters.gift_config &&
      (getters.gift_config.auto_claim_enabled ||
        getters.gift_config.collect_shipping_address) &&
      !getters.resetShippingAddressFieldFlag
    ) {
      this.steps.push("shipping_address");
    }
  }

  [PAYMENT_SECTION](state, rootState, dispatch, getters) {
    super[PAYMENT_SECTION](state, rootState, dispatch, getters);
  }

  [SUBSCRIPTION_SECTION](state, rootState, dispatch, getters) {
    super[SUBSCRIPTION_SECTION](state, rootState, dispatch, getters);
  }

  [GIFT_SECTION](state, rootState, dispatch, getters) {
    this.steps.push("gift_details");
  }
}
